// Dropdown constants and limits
export const MAX_LANGUAGES_ALLOWED = 20;
export const LANGUAGE_LIMIT_WARNING = "Maximum limit of 20 languages reached.";
export const LANGUAGE_IMPORT_ERROR = (total: number) =>
  `Import failed: Maximum of 20 languages allowed. Your selection would result in ${total} languages.`;
